export default __webpack_public_path__ + "static/media/meTabLeftBranding.ba7a81d2.svg";